import React from 'react'
import { cx } from '@/lib/utils'
import styles from './FormSelect.module.scss'

interface FormSelectOption { value: string; label: string }

interface FormSelectProps {
  id: string
  label: string
  value: string
  onChange: (value: string) => void
  options: FormSelectOption[]
  placeholder?: string
  error?: string
  required?: boolean
}

export const FormSelect: React.FC<FormSelectProps> = ({
  id, label, value, onChange, options, placeholder, error, required = false,
}) => (
  <div className={styles.field}>
    <label className={styles.label} htmlFor={id}>
      {label}
      {required && <span className={styles.required}>*</span>}
    </label>
    <select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={cx(styles.select, error && styles.selectError)}
      required={required}
    >
      {placeholder && <option value="">{placeholder}</option>}
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
    {error && <span className={styles.error}>{error}</span>}
  </div>
)
